import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function NewsletterSection() {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);

    const urlEncoded = new URLSearchParams();
    urlEncoded.append('email', email);

    try {
      const res = await fetch('https://readdy.ai/api/form/d8ofqhp8gb8kvsd0o9o0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlEncoded.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
        setEmail('');
      }
    } catch {
      // silently handle
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-primary-800">
      <div className="max-w-[700px] mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
          {t('newsletter.title')}
        </h2>
        <p className="text-sm text-foreground-200 mb-8 leading-relaxed">
          {t('newsletter.description')}
        </p>

        {submitted ? (
          <p className="text-accent-300 font-medium text-sm">
            {t('newsletter.success')}
          </p>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            id="newsletter-form"
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('newsletter.placeholder')}
              className="flex-1 w-full px-5 py-3 bg-white/10 border border-white/20 rounded-full text-sm text-white placeholder:text-foreground-300 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-400 transition-colors"
            />
            <button
              type="submit"
              disabled={submitting}
              className="w-full sm:w-auto px-6 py-3 bg-accent-500 text-primary-900 font-semibold text-sm rounded-full hover:bg-accent-400 disabled:opacity-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {submitting ? t('newsletter.subscribing') : t('newsletter.button')}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}